import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { StockTakeSessionDeviceModel } from '../../../../../../models/aggregates/erp/stock';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { StockTakeSessionDeviceCriteriaModelQuery, StockTakeSessionDeviceQueryCriteriaClass } from '../../../criteria/stock';

@Injectable({ providedIn: 'root' })
export class StockTakeSessionDeviceService extends BaseApiTemplateService<StockTakeSessionDeviceModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-device';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-device';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'stocktake-device';
    this.httpClient = theHttp;
  }

  getStockTakeSessionDeviceByCriteria(visa: ApiVisa, criteria?: StockTakeSessionDeviceQueryCriteriaClass):
    Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildStockTakeDeviceCriteria = new StockTakeSessionDeviceCriteriaModelQuery(criteria);
    // console.log('stockDevice: ', this.apiUrl + '/query?' + buildStockTakeDeviceCriteria.query);
    return this.httpClient.get<PagingResponseModel<any>>(this.apiUrl + '/query?' + buildStockTakeDeviceCriteria.query, this.getHttpHeader(visa));
  }

}
